import { defineBoot } from '#q-app'
import { createI18n } from 'vue-i18n'
import messages from 'src/i18n'

/**
 * Application-wide i18n instance. Exported so that code outside components
 * (e.g. Pinia stores) can translate via i18n.global.t().
 */
export const i18n = createI18n({
  legacy: false,
  locale: 'de',
  globalInjection: true,
  messages
})

export default defineBoot(({ app }) => {
  // Set i18n instance on app
  app.use(i18n)
})
